<template>
    <!-- <div :style="{
        'height': '100vh',
        'background-image': 'url(/assets/image/background.jpg)',
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
        'background-position': 'center',

        'display': 'flex',
        'align-items': 'center',
        'justify-content': 'center',
    }">
        <div>
            <div class="vh-card vh-card-body vh-card-white"
                :style="{
                    'border-radius': '10px',
                }">

                <div class="login-image">
                    <img
                        :src="'/assets/image/logo-with-title-h.png'" alt="Auto Service logo">
                </div>

                <div class="vh-text-center">

                    <h3 class="vh-text-bold">
                        Sign in your account
                    </h3>
                </div>

                <div class="vh-margin-top vh-text-center">
                    <div class="horizontal-form">
                        <form class="vh-form-stacked vh-margin-medium-top"
                            @submit.prevent="submit()">
                            <fieldset class="vh-fieldset">

                                <div class="vh-margin">
                                    <div class="login-input">
                                        <input
                                            type="text"
                                            required="required"
                                            placeholder="Username"
                                            :readonly="isLoading('signin')"
                                            v-model="form.username">
                                        <vh-input-error
                                            v-if="hasError('username')"
                                            :label="errors.username[0]" />
                                    </div>
                                </div>

                                <div class="vh-margin">
                                    <div class="login-input">
                                        <input
                                            type="password"
                                            required="required"
                                            placeholder="Password"
                                            :readonly="isLoading('signin')"
                                            v-model="form.password">
                                        <vh-input-error
                                            v-if="hasError('username')"
                                            :label="errors.password[0]" />
                                    </div>
                                </div>

                                <vh-input-error
                                    v-if="hasError('account')"
                                    :label="errors.account[0]" />

                            </fieldset>

                            <div class="vh-margin-top">

                                <button
                                    type="submit"
                                    class="vh-button vh-button-default vh-width-1-1 vh-text-bold custom-login-button"
                                    :disabled="isLoading('signin')">
                                    <span v-if="!isLoading('signin')">
                                        Sign In
                                    </span>
                                    <span v-else>
                                        Signing in...
                                    </span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="vh-margin-top vh-text-center">
                    <small >
                        {{appTitle}} - {{appVersion}}
                    </small>
                </div>
            </div>
        </div>
        
    </div> -->
    <div class="login-body">

        <div class="login-box">

            <form @submit.prevent="submit()">

                <div class="login-image">
                    <img :src="'/assets/image/logo-with-title-h.png'" alt="Auto Service logo">
                </div>

                <div class="login-title">
                    <h3>Sign-in into your account</h3>
                </div>

                <div class="input-box">
                    <input
                        type="text"
                        required="required"
                        placeholder="Username"
                        :readonly="isLoading('signin')"
                        v-model="form.username">
                    <vh-input-error
                        v-if="hasError('username')"
                        :label="errors.username[0]" />
                </div>

                <div class="input-box">
                    <input
                        type="password"
                        required="required"
                        placeholder="Password"
                        :readonly="isLoading('signin')"
                        v-model="form.password">
                    <vh-input-error
                        v-if="hasError('username')"
                        :label="errors.password[0]" />
                </div>

                <div class="login-button">
                    <button
                        type="submit"
                        :disabled="isLoading('signin')">
                        <span v-if="!isLoading('signin')">
                            Sign In
                        </span>
                        <span v-else>
                            Signing in...
                        </span>
                    </button>
                </div>

                <div class="login-footer">
                    <p>{{appTitle}} - {{appVersion}}</p>
                </div>

            </form>

        </div>

    </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { Form, Toast } from '@/utils';

export default
{
    name: 'SignIn',

    data()
    {
        return {
            errors: {},

            form:
            {
                username: '',
                password: '',
            },

            submitLoading: false,
        };
    },

    created()
    {
        
    },

    computed:
    {
        ...mapGetters({
            isLoading: 'auth/isLoading',
        }),

        appVersion()
        {
            return process.env.VUE_APP_VERSION;
        },

        appTitle()
        {
            return process.env.VUE_APP_TITLE;
        },
    },

    methods:
    {
        ...mapActions({
            signin: 'auth/signin',
        }),

        async submit()
        {
            this.errors = {};

            const response = await this.signin({
                form: this.form
            });

            if (response.status === 200)
            {
                this.$router.push(`/dashboard`);
            }
            else if (response.status === 422)
            {
                this.errors = response.data.errors;
            }
            else if (response.status === 403)
            {
                let message = 'Sorry, you cannot perform this action.';

                Toast.error({
                    message: response.data.error.description
                        ? response.data.error.description
                        : message,
                });
            }
            else if (response.status === 404)
            {
                let message = 'Data not found. Please try again.';

                Toast.error({
                    message: response.data.error.description
                        ? response.data.error.description
                        : message,
                });
            }
            else
            {
                let message = 'Something went wrong. Please try again.';

                Toast.error({
                    message: response.data.error.description
                        ? response.data.error.description
                        : message,
                });
            }
        },

        hasError(name = null)
        {
            return Form.hasError(this.errors, name);
        },

    },
};
</script>

<style scoped>
.custom-input {
    border-radius: 50px !important;
    height: 50px;
    padding-left: 30px;
    width: 100%;
    border: .75px solid #DCDCDC;
}

.custom-login-button {
    background: #333333;
    border: none;
    color: #e0e0e0;
    border-radius: 50px;
    height: 50px;
    width: 100%;
}

.custom-login-button:hover {
    background: #424242;
    color: #fff;
}
</style>